"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CM2_PER_M2 = exports.GRAMS_PER_KILOGRAM = exports.GRAMS_PER_TONNE = exports.ImpactType = void 0;
var ImpactType;
(function (ImpactType) {
    ImpactType["TREES"] = "TREES";
    ImpactType["CARBON_OFFSETS"] = "CARBON_OFFSETS";
    ImpactType["CARBON_REMOVAL"] = "CARBON_REMOVAL";
    ImpactType["HABITAT_RESTORATION"] = "HABITAT_RESTORATION";
})(ImpactType = exports.ImpactType || (exports.ImpactType = {}));
exports.GRAMS_PER_TONNE = 1000000;
exports.GRAMS_PER_KILOGRAM = 1000;
exports.CM2_PER_M2 = 10000;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5pdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaW1wYWN0L3VuaXRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksVUFLWDtBQUxELFdBQVksVUFBVTtJQUNwQiw2QkFBZSxDQUFBO0lBQ2YsK0NBQWlDLENBQUE7SUFDakMsK0NBQWlDLENBQUE7SUFDakMseURBQTJDLENBQUE7QUFDN0MsQ0FBQyxFQUxXLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBS3JCO0FBTVksUUFBQSxlQUFlLEdBQUcsT0FBUyxDQUFDO0FBQzVCLFFBQUEsa0JBQWtCLEdBQUcsSUFBSyxDQUFDO0FBQzNCLFFBQUEsVUFBVSxHQUFHLEtBQU0sQ0FBQyJ9